import React from "react";
import cx from "classnames";
import global from "../../../scss/dhp.scss";

let style = Object.assign({}, global);

const CompanyLoader = () => {
  return (
    <div className={cx(style["p-2"], style["pb-3"])}>
      <ul className={cx(style["skeleton-loader-area"], style["flex-column"], style["align-items-start"])}>
        <li className={cx(style["loader-item"], style["w-100"], style["my-2"])}></li>
        <li className={cx(style["loader-item"], style["w-75"], style["my-2"])}></li>
      </ul>
    </div>
  );
};

export default CompanyLoader;
